import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { updateModal } from '../../../store/common/common_action'
import { focusElemnt, getGSTNAddress, navigation2 } from '../../common/helper'
import * as iid from '../../common/bookingElementId'
import * as mdt from '../../common/modaltypes'
import Modal from '../../common/modal'

const GstnValidationUI = (props) => {
  const gst = props?.gstnValidationData
  const gstd = gst?.data
  const buttonRef = useRef(null)
  useEffect(() => {
    buttonRef.current.focus()
  }, [])
  return (
    <Modal
      headTxt={`GSTIN Status`}
      width={'30%'}
      updateModal={() => {
        props.setGstnModal(false)
      }}
    >
      <Stack direction="column" sx={{ padding: '15px 0px' }} className="booking-confirmation-section">
        <Box sx={{ width: '100%', padding: '12px 15px' }} className="sender-receiver">
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              GSTN
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gst?.GSTN}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              Company Name
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd?.CompanyName}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              Address
            </Typography>
            :
            <Typography className="sr-value" style={{ alignItems: 'left', whiteSpace: 'initial' }}>
              {getGSTNAddress(gstd)}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              Status
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd.Status}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '100%', padding: '12px 15px' }}>
          <Button
            ref={buttonRef}
            variant="contained"
            className="btn btn-primary"
            onClick={(e) => {
              props.setGstnModal(false)
              focusElemnt(props?.gstnValidationData?.navigation === 2 ? iid.destinationCity : iid.RecName)
            }}
            sx={{
              width: '100%',
            }}
          >
            OK
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(GstnValidationUI)
